



















import { Vue, Component } from 'vue-property-decorator';
import One from './components/One.vue';
import Two from './components/Two.vue';
import Three from './components/Three.vue';
import Four from './components/Four.vue';
import Five from './components/Five.vue';
import Six from './components/Six.vue';

@Component({
  components: {
    One,
    Two,
    Three,
    Four,
    Five,
    Six,
  },
})
export default class Rules extends Vue {
  currentIndex: number = 0;
  activeComponent: string = 'One';
  tabs = [
    {
      id: 1,
      text: '活动意义',
      cmp: 'One',
    },
    {
      id: 2,
      text: '组织机构',
      cmp: 'Two',
    },
    {
      id: 3,
      text: '奖项设置',
      cmp: 'Three',
    },
    {
      id: 4,
      text: '参评条件',
      cmp: 'Four',
    },
    {
      id: 5,
      text: '评选维度',
      cmp: 'Five',
    },
    {
      id: 6,
      text: '评选流程',
      cmp: 'Six',
    },
  ];
  handleClickItem(item: any, index: number) {
    this.currentIndex = index;
    this.activeComponent = item.cmp;
  }
}
